const en_US = {
  title: 'Quick View',
  list: {
    title: 'List',
    public: 'Public',
    export: 'Export',
    add_title: 'Add',
    edit_title: 'Edit',
    import_title: 'Import',
    export_title: 'Export',
    name: 'Name',
    isPublic: 'Is it public',
    filters: 'Filters',
    dynamicLabels: 'Dynamic Labels',
    dimensionLabels: 'Dimension Labels',
    preview: 'Preview',
    count: 'Count',
    sample: 'Sample',
    import_label: 'JSON',
    copy: 'Copy JSON to clipboard',
    allSelect: 'All Select',
    clear: 'Clear',
  },
  metrics: {
    title: 'Metrics',
    search_placeholder: 'Space separated multiple keywords',
    clear: 'Clear',
    noData: 'No data, please select the left Labels',
  },
  graph: {
    function: 'Function',
    none: 'None',
    offset: 'Offset',
    aggregation: 'Aggregation',
    aggregation_by: 'By',
    calc: 'Calc',
  },
};
export default en_US;
